import { api } from '@services';

interface IDeleteTaskFile {
  taskId: string;
  taskFileId: string;
}

const deleteTaskFile = async ({
  taskId,
  taskFileId,
}: IDeleteTaskFile): Promise<void> => {
  await api.delete(`/tasks/${taskId}/files/${taskFileId}`);
};

export { deleteTaskFile };
